import React from 'react';
import moment from 'moment';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'Active', value: <FiberManualRecordIcon fontSize="small" style={{ color: data.status ? '#4caf50' : '#f44336' }} />, inHeader: true, hideLabel: true },
        { label: 'Male Labour Cost', value: data.maleCost },
        { label: 'Female Labour Cost', value: data.femaleCost },
        { label: 'Overtime Cost', value: data.overtimeCost },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={moment(data.date).format("DD-MM-YYYY")}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
